import type { InterfaceLanguageCode } from "src/app/consts/AvailableLanguages";
import { FormattedMessage } from "react-intl";
import React from "react";

export interface IInterfaceLanguageNameProps {
  languageCode: InterfaceLanguageCode;
}

export const InterfaceLanguageName = ({
  languageCode,
}: IInterfaceLanguageNameProps) => (
  <FormattedMessage id={`languageName.${languageCode}`} />
);
